"use strict";

var _classCallCheck = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var DOMException = require("../../web-idl/DOMException.js");

var documentBaseURLSerialized = require("../helpers/document-base-url.js").documentBaseURLSerialized;

var parseURLToResultingURLRecord = require("../helpers/document-base-url.js").parseURLToResultingURLRecord;

var traverseHistory = require("./navigation.js").traverseHistory;

exports.implementation = /*#__PURE__*/function () {
  function HistoryImpl(args, privateData) {
    _classCallCheck(this, HistoryImpl);

    this._window = privateData.window;
    this._document = privateData.document;
    this._actAsIfLocationReloadCalled = privateData.actAsIfLocationReloadCalled;
    this._state = null;
    this._latestEntry = null;
    this._historyTraversalQueue = new Set();
  }

  _createClass(HistoryImpl, [{
    key: "_guardAgainstInactiveDocuments",
    value: function _guardAgainstInactiveDocuments() {
      if (!this._window) {
        throw new DOMException(DOMException.SECURITY_ERR, "History object is associated with a document that is not fully active.");
      }
    }
  }, {
    key: "go",
    value: function go(delta) {
      var _this = this;

      this._guardAgainstInactiveDocuments();

      if (delta === 0) {
        this._actAsIfLocationReloadCalled();
      } else {
        this._queueHistoryTraversalTask(function () {
          var newIndex = _this._window._currentSessionHistoryEntryIndex + delta;

          if (newIndex < 0 || newIndex >= _this._window._sessionHistory.length) {
            return;
          }

          var specifiedEntry = _this._window._sessionHistory[newIndex]; // Not implemented: unload a document guard
          // Not clear that this should be queued. html/browsers/history/the-history-interface/004.html can be fixed
          // by removing the queue, but doing so breaks some tests in history.js that also pass in browsers.

          _this._queueHistoryTraversalTask(function () {
            return traverseHistory(_this._window, specifiedEntry);
          });
        });
      }
    }
  }, {
    key: "back",
    value: function back() {
      this.go(-1);
    }
  }, {
    key: "forward",
    value: function forward() {
      this.go(+1);
    }
  }, {
    key: "pushState",
    value: function pushState(data, title, url) {
      this._sharedPushAndReplaceState(data, title, url, "pushState");
    }
  }, {
    key: "replaceState",
    value: function replaceState(data, title, url) {
      this._sharedPushAndReplaceState(data, title, url, "replaceState");
    }
  }, {
    key: "_sharedPushAndReplaceState",
    value: function _sharedPushAndReplaceState(data, title, url, methodName) {
      this._guardAgainstInactiveDocuments(); // TODO structured clone data


      var newURL;

      if (url !== null) {
        // Not implemented: use of entry settings object's API base URL. Instead we just use the document base URL. The
        // difference matters in the case of cross-frame calls.
        newURL = parseURLToResultingURLRecord(url, this._document);

        if (newURL === "failure") {
          throw new DOMException(DOMException.SECURITY_ERR, "Could not parse url argument \"".concat(url, "\" to ").concat(methodName, " ") + "against base URL \"".concat(documentBaseURLSerialized(this._document), "\"."));
        }

        if (newURL.scheme !== this._document._URL.scheme || newURL.username !== this._document._URL.username || newURL.password !== this._document._URL.password || newURL.host !== this._document._URL.host || newURL.port !== this._document._URL.port || newURL.cannotBeABaseURL !== this._document._URL.cannotBeABaseURL) {
          throw new DOMException(DOMException.SECURITY_ERR, "".concat(methodName, " cannot update history to a URL which ") + "differs in components other than in path, query, or fragment.");
        } // Not implemented: origin check (seems to only apply to documents with weird origins, e.g. sandboxed ones)

      } else {
        newURL = this._window._sessionHistory[this._window._currentSessionHistoryEntryIndex].url;
      }

      if (methodName === "pushState") {
        this._window._sessionHistory.splice(this._window._currentSessionHistoryEntryIndex + 1, Infinity);

        this._clearHistoryTraversalTasks();

        this._window._sessionHistory.push({
          document: this._document,
          stateObject: data,
          title: title,
          url: newURL
        });

        this._window._currentSessionHistoryEntryIndex = this._window._sessionHistory.length - 1;
      } else {
        var currentEntry = this._window._sessionHistory[this._window._currentSessionHistoryEntryIndex];
        currentEntry.stateObject = data;
        currentEntry.title = title;
        currentEntry.url = newURL;
      }

      this._document._URL = newURL;
      this._state = data; // TODO clone again!! O_o

      this._latestEntry = this._window._sessionHistory[this._window._currentSessionHistoryEntryIndex];
    }
  }, {
    key: "_queueHistoryTraversalTask",
    value: function _queueHistoryTraversalTask(fn) {
      var _this2 = this;

      var timeoutId = this._window.setTimeout(function () {
        _this2._historyTraversalQueue.delete(timeoutId);

        fn();
      }, 0);

      this._historyTraversalQueue.add(timeoutId);
    }
  }, {
    key: "_clearHistoryTraversalTasks",
    value: function _clearHistoryTraversalTasks() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this._historyTraversalQueue[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var timeoutId = _step.value;

          this._window.clearTimeout(timeoutId);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this._historyTraversalQueue.clear();
    }
  }, {
    key: "length",
    get: function get() {
      this._guardAgainstInactiveDocuments();

      return this._window._sessionHistory.length;
    }
  }, {
    key: "state",
    get: function get() {
      this._guardAgainstInactiveDocuments();

      return this._state;
    }
  }]);

  return HistoryImpl;
}();